module.exports = "mat-progress-bar {\n  position: absolute;\n  z-index: 10000; }\n"